import { render } from "./ConnectToFacebook.vue?vue&type=template&id=8b7f65ec"
import script from "./ConnectToFacebook.vue?vue&type=script&lang=js"
export * from "./ConnectToFacebook.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__